import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const EmailIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--emailIcon')}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      d="M27.954 7.5v17h-24v-17h24Zm-22.5 2.299V23h21V9.869L16 17.948 5.454 9.799ZM25.125 9H6.875L16 16.052 25.125 9Z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default EmailIcon;
